import React from 'react'
import './Auth.scss'

function SideBar() {
  return (
    <div className="sidebar">
      <a href="https://rs.school/">
        <div className="sidebar__rslogo" />
      </a>
      <div className="sidebar__astronaut" />
    </div>
  )
}

export default SideBar
